import {
    accountSessionsSlice,
    addressKeysReducer,
    addressesReducer,
    apiStatusReducer,
    delegatedAccessReducer,
    domainsReducer,
    entitlementsReducer,
    featureTourReducer,
    groupMembersReducer,
    groupMembershipsReducer,
    groupOwnerInvitesReducer,
    groupsReducer,
    inactiveKeysReducer,
    ktSlice,
    memberReducer,
    membersReducer,
    organizationKeyReducer,
    organizationReducer,
    organizationRolesReducer,
    organizationThemeSlice,
    passwordReminderReducer,
    paymentMethodsReducer,
    paymentStatusReducer,
    plansReducer,
    previousSubscriptionReducer,
    protonDomainsReducer,
    referralInfoReducer,
    referralsReducer,
    scheduleCallReducer,
    subscriptionReducer,
    userInvitationsReducer,
    userKeysReducer,
    userPermissionsReducer,
    userReducer,
    userSettingsReducer,
    welcomeFlagsReducer,
} from '@proton/account';
import { contactEmailsReducer } from '@proton/account/contactEmails';
import { paymentsInitReducer } from '@proton/account/paymentsInit';
import { sessionRecoverySlice } from '@proton/account/recovery/sessionRecovery';
import { featuresReducer } from '@proton/features';
import { contactsReducer } from '@proton/mail/store/contacts';
import { contactReducer } from '@proton/mail/store/contacts/contactSlice';
import { importerConfigReducer } from '@proton/mail/store/importerConfig';
import { categoriesReducer } from '@proton/mail/store/labels';
import { mailSettingsReducer } from '@proton/mail/store/mailSettings';
import { selectPersistModel } from '@proton/redux-utilities/creator';

export const sharedReducers = {
    ...apiStatusReducer,
    ...userReducer,
    ...userKeysReducer,
    ...plansReducer,
    ...addressesReducer,
    ...addressKeysReducer,
    inactiveKeys: inactiveKeysReducer,
    ...userSettingsReducer,
    ...mailSettingsReducer,
    ...subscriptionReducer,
    ...previousSubscriptionReducer,
    ...paymentMethodsReducer,
    ...paymentStatusReducer,
    ...paymentsInitReducer,
    ...organizationReducer,
    ...organizationKeyReducer,
    ...organizationRolesReducer,
    ...protonDomainsReducer,
    ...domainsReducer,
    ...entitlementsReducer,
    organizationTheme: organizationThemeSlice.reducer,
    ...userInvitationsReducer,
    ...contactReducer,
    ...contactsReducer,
    ...contactEmailsReducer,
    ...categoriesReducer,
    ...importerConfigReducer,
    ...welcomeFlagsReducer,
    ...memberReducer,
    ...membersReducer,
    ...scheduleCallReducer,
    ...groupsReducer,
    ...groupMembersReducer,
    ...groupMembershipsReducer,
    ...groupOwnerInvitesReducer,
    ...featureTourReducer,
    ...referralInfoReducer,
    ...referralsReducer,
    ...userPermissionsReducer,
    kt: ktSlice.reducer,
    features: featuresReducer.reducer,
    sessions: accountSessionsSlice.reducer,
    sessionRecovery: sessionRecoverySlice.reducer,
    ...delegatedAccessReducer,
    ...passwordReminderReducer,
};

export const sharedPersistReducer: Partial<{ [key in keyof typeof sharedReducers]: any }> = {
    user: selectPersistModel,
    addresses: selectPersistModel,
    userSettings: selectPersistModel,
    mailSettings: selectPersistModel,
    subscription: selectPersistModel,
    contacts: selectPersistModel,
    contactEmails: selectPersistModel,
    plans: selectPersistModel,
    categories: selectPersistModel,
    organization: selectPersistModel,
    userInvitations: selectPersistModel,
    protonDomains: selectPersistModel,
    domains: selectPersistModel,
    previousSubscription: selectPersistModel,
    referralInfo: selectPersistModel,
    features: (state: any) => state,
};
